import DropdownMenu from 'components/dropdownMenu/dropDownMenu';
import { observer } from 'mobx-react-lite';
import { MobxContext } from 'mobx/mobxContext';
import React, { useContext, useEffect, useState } from 'react';
import UiWrapper from 'uiWrapper';

export default observer(function App() {
  const {
    mobxStore: { dataStore },
  } = useContext(MobxContext);

  useEffect(() => {
    if (!dataStore.data && !dataStore.isPending && !dataStore.isError) {
      dataStore.fetch();
    }
  }, [dataStore, dataStore.data, dataStore.isPending]);

  // const [menuElement, setMenuElement] = useState<HTMLElement | null>(null);
  //
  // useEffect(() => {
  //   // элемент для ориентира по ширине виджета
  //   const menuEl = document.getElementsByClassName(
  //     process.env.REACT_APP_MENU_BLOCK || ''
  //   )[0] as HTMLElement | null;
  //   setMenuElement(menuEl);
  //
  //   console.log('menuElement', menuElement?.getBoundingClientRect().width);
  // }, [menuElement]);

  return (
    <UiWrapper>
      {dataStore.data ? (
        <DropdownMenu
          data={dataStore.data}
          initialIsOpen={false}
        ></DropdownMenu>
      ) : (
        <></>
      )}
    </UiWrapper>
  );
});
